export default "__VITE_ASSET__CNhZuKlv__"